export default __webpack_public_path__ + "cb68fdd7edfbab2b56566a480fe5ab5a.png";